(function ($) {
  const $nodes = $('.node--type-serie.node--view-mode-highlighted, .node--type-serie.node--view-mode-full, .node--type-serie.node--view-mode-serie-carousel');

  $nodes.each(function () {
    const $buttonsContainer = $(this).find('.hero-buttons');

    const $playButton = $('<button/>').text('Afspelen').addClass(['btn', 'btn--primary', 'btn--play']);
    const $trailerButton = $('<button/>').text('Bekijk trailer').addClass(['btn', 'btn--white', 'btn--play']);
    
    // Add buttons to text
    if ($(this).hasClass('node--view-mode-highlighted')){
      if ($(this).find(".hero--video .player-blinder").length > 0){
        $buttonsContainer.append($playButton.addClass('js-hero-play--episode'));
      }
      $(this).find('.hero-buttons').append($(this).find(".hero--video > a"));
    }
    if ($(this).hasClass('node--view-mode-serie-carousel')){
      if ($(this).find(".field--name-field-episodes .player-blinder").length > 0){
        $buttonsContainer.append($playButton.addClass('js-hero-play--episode'));
      }
      if ($(this).find(".hero--teaser .player-blinder").length > 0){
        $buttonsContainer.append($trailerButton.addClass('js-hero-play--trailer'));
      }
    } else {
      if ($(".field--name-field-episodes .player-blinder").length > 0){
        $buttonsContainer.append($playButton.addClass('js-hero-play--newest'));
      }       
    }
  })

})(jQuery);